function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
import { Loading } from "./Loading";
var htmlTag = {
    a1: 'span',
    a2: 'h1',
    b1: 'span',
    b2: 'h1',
    c1: 'span',
    c2: 'h2',
    d1: 'span',
    d2: 'h2',
    e1: 'span',
    e2: 'h2',
    f1: 'span',
    f2: 'h3',
    g1: 'p',
    g2: 'span',
    i1: 'p',
    i2: 'span',
    j1: 'span',
    j2: 'p',
    k3: 'span'
};
var TextContainer = styled(Typography, {
    shouldForwardProp: function(propName) {
        return propName !== 'isLoading';
    }
})(function(props) {
    var _props_theme_palette_props_backgroundColor, _props_theme_palette_props_bgcolor, _props_theme_palette_props_color;
    return {
        backgroundColor: ((_props_theme_palette_props_backgroundColor = props.theme.palette[props.backgroundColor]) === null || _props_theme_palette_props_backgroundColor === void 0 ? void 0 : _props_theme_palette_props_backgroundColor.main) || ((_props_theme_palette_props_bgcolor = props.theme.palette[props.bgcolor]) === null || _props_theme_palette_props_bgcolor === void 0 ? void 0 : _props_theme_palette_props_bgcolor.main),
        color: (_props_theme_palette_props_color = props.theme.palette[props.color]) === null || _props_theme_palette_props_color === void 0 ? void 0 : _props_theme_palette_props_color.main
    };
});
TextContainer.displayName = 'TextContainer';
export var Text = function(_param) {
    var _param_maxWidth = _param.maxWidth, maxWidth = _param_maxWidth === void 0 ? '45rem' : _param_maxWidth, _param_mb = _param.mb, mb = _param_mb === void 0 ? 4 : _param_mb, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'g1' : _param_variant, props = _object_without_properties(_param, [
        "maxWidth",
        "mb",
        "variant"
    ]);
    return /*#__PURE__*/ _jsx(TextContainer, _object_spread_props(_object_spread({
        component: props.component || htmlTag[variant],
        "data-component": "text",
        "data-variant": variant,
        maxWidth: maxWidth,
        mb: mb,
        variant: variant
    }, props), {
        "aria-label": props.isLoading ? 'Loading' : props['aria-label'],
        children: props.isLoading ? /*#__PURE__*/ _jsx(Loading, {
            variant: variant
        }) : props.children
    }));
};
Text.displayName = 'Text';

//# sourceMappingURL=Text.js.map